import { render } from "./IconCloseModal.vue?vue&type=template&id=73d739f4"
import script from "./IconCloseModal.vue?vue&type=script&lang=js"
export * from "./IconCloseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__